// https://github.com/wix-private/wix-answers-server/blob/0a9ba2edbbf8a900e48f258dd56a4fdadcec510a/answers/wix-answers-core/src/main/java/com/wixpress/answers/common/exceptions/Errors.java#L110
export var TwitterErrorCode;
(function (TwitterErrorCode) {
    TwitterErrorCode[TwitterErrorCode["CONNECT_ACCOUNT_FAIL_GENERAL"] = -210010] = "CONNECT_ACCOUNT_FAIL_GENERAL";
    TwitterErrorCode[TwitterErrorCode["ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT"] = -210011] = "ACCOUNT_ALREADY_CONNECTED_TO_OTHER_TENANT";
    TwitterErrorCode[TwitterErrorCode["ACCOUNT_ALREADY_CONNECTED_TO_TENANT"] = -210012] = "ACCOUNT_ALREADY_CONNECTED_TO_TENANT";
    TwitterErrorCode[TwitterErrorCode["UNEXPECTED_AUTHORIZED_ACCOUNT"] = -210013] = "UNEXPECTED_AUTHORIZED_ACCOUNT";
})(TwitterErrorCode || (TwitterErrorCode = {}));
export var twitterRelativePath = '/twitter';
export var getCurrentLocation = function (pathName) { return "" + window.location.origin + (pathName || window.location.pathname); };
export var createTwitterApi = function (baseUrl, http) {
    var twitterApiUrl = baseUrl + twitterRelativePath;
    return {
        addAccount: function (pathName) {
            var url = getCurrentLocation(pathName);
            var encodedUrl = encodeURIComponent(url);
            var twitterAuthUrl = twitterApiUrl + "/authURL?redirectUrl=" + encodedUrl;
            window.location.href = twitterAuthUrl;
        },
        reconnectAccount: function (id, pathName) {
            var url = getCurrentLocation(pathName);
            var encodedUrl = encodeURIComponent(url);
            var twitterAuthUrl = twitterApiUrl + "/authURL/" + id + "?redirectUrl=" + encodedUrl;
            window.location.href = twitterAuthUrl;
        },
        getAccounts: function (validate) { return http.get(twitterApiUrl + "/accounts?validate=" + !!validate); },
        updateAccount: function (dto) { return http.put(twitterApiUrl + "/accounts/" + dto.id, dto); },
        deleteAccount: function (id) { return http.delete(twitterApiUrl + "/accounts/" + id); },
    };
};
//# sourceMappingURL=index.js.map